<template>
  <div class="page-view">
    <!-- 面包屑 -->
    <a-breadcrumb class="page-breadcrumb">
      <a-breadcrumb-item>系统设置</a-breadcrumb-item>
      <a-breadcrumb-item>角色管理</a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 页面内容 -->
    <div class="page-content">
      <!-- 新增 -->
      <div class="tool-view">
        <a-button type="primary" @click="editDepartment()">新增角色</a-button>
      </div>
      <!-- 列表 -->
      <a-table
        :loading="loading"
        :columns="columns"
        :data-source="dataSource"
        :row-key="(record) => record.id"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <!-- 操作 -->
        <template slot="operate" slot-scope="text, record">
          <!-- 管理员为默认角色，不可编辑-->
          <a class="operate-item"
            style="margin-right: 10px"
            :disabled="!record.can_edit"
            @click="editDepartment(record)"
          >
            编辑
          </a>
        </template>
      </a-table>
    </div>
    <!-- 新增、编辑角色 -->
    <EditModal ref="EditModal" @success="getRoleList" />
  </div>
</template>

<script>
import { getRoleList } from '@/api/request'
import EditModal from './components-role/EditModal'
// 列字段
const columns = [
  {
    title: '角色',
    dataIndex: 'show_name',
    key: 'show_name'
  },
  {
    title: '操作',
    dataIndex: 'operate',
    key: 'operate',
    scopedSlots: { customRender: 'operate' }
  }
]
export default {
  components: {
    EditModal
  },
  data () {
    return {
      // 列字段
      columns,
      // 数据源
      dataSource: [],
      // 加载
      loading: false,
      // 分页器
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true
      },
    }
  },
  created () {
    this.getRoleList()
  },
  methods: {
    // 分页
    handleTableChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getRoleList()
    },
    // 获取角色列表
    getRoleList () {
      this.loading = true
      const params = {
        page: this.pagination.current,
        page_size: this.pagination.pageSize
      }
      getRoleList(params).then(res => {
        this.loading = false
        const { code, data, msg } = res
        if (code === 0) {
          this.dataSource = data.data
          this.pagination.total = data.total
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 新增、编辑角色
    editDepartment (record) {
      this.$refs['EditModal'].showModal(record)
    },
  }
}
</script>

<style lang="less" scoped>
.page-view {
  padding: 24px 32px;
}
.tool-view {
  margin: 0 0 24px;
  display: flex;
  justify-content: flex-end;
}
</style>